import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { SemaforoProtocol } from './components/SemaforoProtocol';
import { WhatYouGet } from './components/WhatYouGet';
import { ProductMockup } from './components/ProductMockup';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { Transformation } from './components/Transformation';
import { FAQ } from './components/FAQ';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
import { Button } from './components/ui/Button';
import { initMetaPixel } from './components/utils/metaPixel';
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-neutral-950 text-neutral-100 font-sans selection:bg-brand/30 selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <SemaforoProtocol data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <ProductMockup data-id="element-6" />
      <WhoIsFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Transformation data-id="element-9" />
      <FAQ data-id="element-10" />
      <PricingCTA data-id="element-11" />
      <Footer data-id="element-12" />

      {/* Sticky Bottom CTA for Mobile/Desktop */}
      <AnimatePresence data-id="element-13">
        {showStickyCTA && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 p-4 z-40 bg-gradient-to-t from-neutral-950 via-neutral-950/90 to-transparent pointer-events-none" data-id="element-14">
            <div className="container mx-auto max-w-4xl flex justify-center pointer-events-auto" data-id="element-15">
              <Button href="#pricing" className="w-full md:w-auto shadow-2xl shadow-brand/20" data-id="element-16">
                ¡QUIERO EL PROTOCOLO AHORA!
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}